type IconProps = {
  className?: string;
  size?: number;
};

export function CrackedShieldIcon({ className = '', size = 24 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Shield outline — primary red */}
      <path
        d="M12 2L4 5V11C4 16 7.5 20.5 12 22C16.5 20.5 20 16 20 11V5L12 2Z"
        fill="#E8192C"
        stroke="#FF2D3F"
        strokeWidth="1.2"
      />
      {/* Inner dark cavity */}
      <path
        d="M12 4L6 6.5V11C6 15 8.8 18.5 12 19.8C15.2 18.5 18 15 18 11V6.5L12 4Z"
        fill="#1A1A1A"
      />
      {/* Crack — jagged line through the shield */}
      <path
        d="M12 5.5L10.5 9L13 11L10.5 13.5L12.5 16L11 18.5"
        stroke="#E8192C"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Exclamation mark */}
      <path
        d="M12 8.5V12.5"
        stroke="#FFFFFF"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
      <circle cx="12" cy="15" r="1" fill="#FFFFFF" />
    </svg>
  );
}

export function HoodedFigureIcon({ className = '', size = 24 }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      {/* Prohibition circle — red */}
      <circle cx="12" cy="12" r="10" fill="none" stroke="#E8192C" strokeWidth="1.5" />
      {/* Hooded figure silhouette — dark */}
      <path
        d="M12 4C9.5 4 8 6 8 8.5C8 10 8.5 11 9 12C7.5 12.5 6 14 6 16.5V19H18V16.5C18 14 16.5 12.5 15 12C15.5 11 16 10 16 8.5C16 6 14.5 4 12 4Z"
        fill="#1A1A1A"
        stroke="#E8192C"
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      {/* Hood point top */}
      <path
        d="M12 3.5L10.5 5.5L12 5L13.5 5.5L12 3.5Z"
        fill="#1A1A1A"
        stroke="#E8192C"
        strokeWidth="1"
        strokeLinejoin="round"
      />
      {/* Eyes — red glow slits */}
      <ellipse cx="10" cy="10" rx="1.2" ry="0.7" fill="#E8192C" />
      <ellipse cx="14" cy="10" rx="1.2" ry="0.7" fill="#E8192C" />
      {/* Prohibition diagonal line */}
      <line
        x1="5"
        y1="5"
        x2="19"
        y2="19"
        stroke="#E8192C"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}
